import axiosGraphQL from './GraphQL/axiosGraphQL';

import {
  CALCULATE_ITEM_SEPARATION_PRICE,
  CANCEL_PURCHASE_INVOICE_ITEM_SEPARATION,
  CANCEL_PURCHASE_SEPARATION,
  COMPLETE_PURCHASE_ORDER,
  CREATE_DEAL_PRICE,
  DELETE_PURCHASE,
  GET_MARKET_GOLD_PRICE,
  GET_MARKET_GOLD_PRICE_APPROVAL,
  GET_PURCHASE_INVOICE,
  GET_PURCHASE_INVOICE_BY_ID,
  GET_PURCHASE_INVOICE_DEAL_PRICE,
  GET_PURCHASE_INVOICE_MATERIALS,
  GET_PURCHASE_INVOICE_SEPARATION,
  GET_PURCHASE_STATUS_COMBOBOX,
  GET_TYPE_CUSTOMER,
  GET_TYPE_OF_DOC,
  GET_TYPE_POLICY_PURCHASE,
  GET_TYPE_PURCHASE,
  GET_UNIT_PURCHASE,
  MOVE_PURCHASE_INVOICE_ITEM,
  ORDER_TEMP_ID_CBX,
  PURCHASE_INVOICE_ITEM_SEPARATION,
  PURCHASE_INVOICE_SEPARATION,
  SAVE_PURCHASE_ORDER,
  SAVE_PURCHASE_ORDER_SEPARATION,
  UPDATE_PURCHASE_ORDER_WEIGHT_FOR_ACCOUNTANT,
} from './GraphQL/Queries/purchaseInvoiceQuery';
import {
  ICalculateItemSeparationPrice,
  ICancelPurchaseInvoiceItemSeparation,
  ICreateDealPrice,
  IGetOrederIdCbx,
  IGetPurchaseInvoice,
  IGetPurchaseInvoiceMaterials,
  IMovePurchaseInvoiceItemParams,
  IPrintFile,
  IPurchaseInvoiceSeparation,
  ISapPurchaseOrder,
  IUpdateOrderParams,
  IUpdatePurchaseOrderForAcountant,
  PURCHASE_INVOICE_VARIABLE,
  SaveOrderParams,
} from './GraphQL/Variables/purchaseInvoice';
import axiosClient from './setup/axiosClient';

interface ICreateMigoParams {
  purchaseOrderId: string;
  migoType: string;
}

interface IGetPurchaseOrderProcessParams {
  purchaseOrderId: string;
  status: boolean;
}

export const PurChaseInvoiceApi = {
  getPurchaseInvoice: async (params: IGetPurchaseInvoice) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_INVOICE,
      variables: PURCHASE_INVOICE_VARIABLE.getPurchaseInvoice(params),
    });
  },
  getPurchaseInvoiceById: async (params: IGetPurchaseInvoice) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_INVOICE_BY_ID,
      variables: PURCHASE_INVOICE_VARIABLE.getPurchaseInvoiceById(params),
    });
  },
  getPurchaseInvoiceDealPrice: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_INVOICE_DEAL_PRICE,
      variables: PURCHASE_INVOICE_VARIABLE.getPurchaseInvoiceDealPrice(id),
    });
  },
  getPurchaseOrderSeparation: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_INVOICE_SEPARATION,
      variables: PURCHASE_INVOICE_VARIABLE.getPurchaseOrderSeparation(id),
    });
  },
  updatePurchaseOrderWeightForAccountant: async (
    params: IUpdatePurchaseOrderForAcountant,
  ) => {
    return await axiosGraphQL.post('/graphql', {
      query: UPDATE_PURCHASE_ORDER_WEIGHT_FOR_ACCOUNTANT,
      variables:
        PURCHASE_INVOICE_VARIABLE.updatePurchaseOrderWeightForAccountant(
          params,
        ),
    });
  },
  purchaseInvoiceSeparation: async (params: IPurchaseInvoiceSeparation) => {
    return await axiosGraphQL.post('/graphql', {
      query: PURCHASE_INVOICE_SEPARATION,
      variables: PURCHASE_INVOICE_VARIABLE.purchaseInvoiceSeparation(params),
    });
  },
  purchaseInvoiceItemSeparation: async (
    params: ICalculateItemSeparationPrice,
  ) => {
    return await axiosGraphQL.post('/graphql', {
      query: PURCHASE_INVOICE_ITEM_SEPARATION,
      variables:
        PURCHASE_INVOICE_VARIABLE.purchaseInvoiceItemSeparation(params),
    });
  },
  cancelPurchaseInvoiceItemSeparation: async (
    params: ICancelPurchaseInvoiceItemSeparation,
  ) => {
    return await axiosGraphQL.post('/graphql', {
      query: CANCEL_PURCHASE_INVOICE_ITEM_SEPARATION,
      variables:
        PURCHASE_INVOICE_VARIABLE.cancelPurchaseInvoiceItemSeparation(params),
    });
  },
  calculateItemSeparationPrice: async (
    params: ICalculateItemSeparationPrice,
  ) => {
    return await axiosGraphQL.post('/graphql', {
      query: CALCULATE_ITEM_SEPARATION_PRICE,
      variables: PURCHASE_INVOICE_VARIABLE.calculateItemSeparationPrice(params),
    });
  },
  cancelPurchaseInvoiceSeparation: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: CANCEL_PURCHASE_SEPARATION,
      variables: PURCHASE_INVOICE_VARIABLE.cancelPurchaseInvoiceSeparation(id),
    });
  },
  movePurchaseInvoiceItem: async (params: IMovePurchaseInvoiceItemParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: MOVE_PURCHASE_INVOICE_ITEM,
      variables: PURCHASE_INVOICE_VARIABLE.movePurchaseInvoiceItem(params),
    });
  },
  createSapPurchaseOrder: async (params: ISapPurchaseOrder) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/create-purchase-order` as string,
      params,
    );
  },
  getSapPurchaseOrderInfo: async (params: ISapPurchaseOrder) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/get-purchase-order-info` as string,
      params,
    );
  },
  cancelSapPurchaseOrder: async (params: ISapPurchaseOrder) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/sap/cancel-purchase-order` as string,
      params,
    );
  },
  savePurchaseOrderSeparation: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SAVE_PURCHASE_ORDER_SEPARATION,
      variables: PURCHASE_INVOICE_VARIABLE.savePurchaseOrderSeparation(id),
    });
  },

  getPurchaseInvoiceMaterials: async (params: IGetPurchaseInvoiceMaterials) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_INVOICE_MATERIALS,
      variables: PURCHASE_INVOICE_VARIABLE.getPurchaseInvoiceMaterials(params),
    });
  },
  getTypePurchase: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TYPE_PURCHASE,
      variables: PURCHASE_INVOICE_VARIABLE.getTypePurchase(),
    });
  },
  getPurchaseStatusCbx: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PURCHASE_STATUS_COMBOBOX,
      variables: PURCHASE_INVOICE_VARIABLE.getPurchaseStatusCbx(),
    });
  },
  getUnitPurchase: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_UNIT_PURCHASE,
      variables: PURCHASE_INVOICE_VARIABLE.getUnitPurchase(),
    });
  },
  getTypePolicyPurchase: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TYPE_POLICY_PURCHASE,
      variables: PURCHASE_INVOICE_VARIABLE.getTypePolicyPurchase(),
    });
  },
  getTypeOfDocPurchase: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TYPE_OF_DOC,
      variables: PURCHASE_INVOICE_VARIABLE.getTypeOfDocPurchase(),
    });
  },
  getTypeCustomer: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_TYPE_CUSTOMER,
      variables: PURCHASE_INVOICE_VARIABLE.getTypeCustomer(),
    });
  },
  getMarketGoldPrice: async (date: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_MARKET_GOLD_PRICE,
      variables: PURCHASE_INVOICE_VARIABLE.getMarketGoldPrice(date),
    });
  },
  getMarketGoldPriceApproval: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_MARKET_GOLD_PRICE_APPROVAL,
      variables: PURCHASE_INVOICE_VARIABLE.getMarketGoldPriceApproval(id),
    });
  },
  updatePurchaseOrder: async (params: IUpdateOrderParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SAVE_PURCHASE_ORDER,
      variables: PURCHASE_INVOICE_VARIABLE.updatePurchaseOrder(params),
    });
  },
  postPurchaseOrder: async (params: SaveOrderParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: SAVE_PURCHASE_ORDER,
      variables: PURCHASE_INVOICE_VARIABLE.postPurchaseOrder(params),
    });
  },
  completePurchaseOrder: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: COMPLETE_PURCHASE_ORDER,
      variables: PURCHASE_INVOICE_VARIABLE.completePurchaseOrder(id),
    });
  },
  createDealPrice: async (params: ICreateDealPrice) => {
    return await axiosGraphQL.post('/graphql', {
      query: CREATE_DEAL_PRICE,
      variables: PURCHASE_INVOICE_VARIABLE.createDealPrice(params),
    });
  },
  getOrderTempIdCbx: async (params: IGetOrederIdCbx) => {
    return await axiosGraphQL.post('/graphql', {
      query: ORDER_TEMP_ID_CBX,
      variables: PURCHASE_INVOICE_VARIABLE.getOrderTempIdCbx(params),
    });
  },
  deletePurchase: async (id: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: DELETE_PURCHASE,
      variables: {
        id: id,
      },
    });
  },
  printFile: async (params: IPrintFile) => {
    return await axiosClient.post(
      `${process.env.REACT_APP_API_BASE_URL}${params.type === 'pdf' || params.type === 'print' ? '/print/printPdf' : '/print/printExcel'}` as string,
      {
        printFunctionId: 'pr10000003',
        params: [
          {
            key: 'purchaseid',
            value: params.id,
          },
        ],
        orientation: 'portrait',
        pageSize: 'A4',
      },
      {
        responseType: 'blob',
      },
    );
  },
  createMigo: async (params: ICreateMigoParams) => {
    return await axiosClient.post('/api/credit/create-migo', params);
  },
  getPurchaseOrderProcess: async (params: IGetPurchaseOrderProcessParams) => {
    const query = `
      query GetPurchaseOrderProcces($input: PurchaseOrderProcessInput!) {
        getPurchaseOrderProcces(input: $input) {
          success
          message
          data {
            id
            purchaseOrderId
            processType
            processCode
            url
            status
            errorMessage
            uniqueCode
            createId
            createDate
            modifyId
            modifyDate
            tcreateUser {
              id
              fullName
            }
          }
        }
      }
    `;
    return await axiosGraphQL.post('/graphql', {
      query,
      variables: { input: params },
    });
  },
};
